import { Link } from "react-router-dom";
import Nav from "@/components/windie/Nav";
import LegalFooter from "@/components/windie/LegalFooter";

const CONTACT_EMAIL = "peterbuics@gmail.com";

const PRIVACY_SECTIONS = [
  {
    heading: "What Windie keeps local",
    body: "Windie is a local runtime. Conversations, SQLite data, provider API keys, installed tools, and model requests are stored or made on your computer. Windie does not upload that local runtime data to Windie's account service.",
  },
  {
    heading: "Account and sign-in data",
    body: "When you choose Google sign-in, Google and our authentication provider may provide basic account information such as your account identifier and email address. We use that information to authenticate you and to let you approve one local Windie runtime for your account.",
  },
  {
    heading: "Service providers and technical data",
    body: "Our website, authentication, and identity providers may process standard technical information needed to operate their services, such as request logs and security information. Their handling of that information is governed by their own privacy terms.",
  },
  {
    heading: "Choices and contact",
    body: "You can stop using Windie at any time and remove its local data with the uninstall command. To ask about your account data or this policy, contact us at",
  },
];

const TERMS_SECTIONS = [
  {
    heading: "Using Windie",
    body: "You may use Windie to run AI software on computers you control or are authorized to use. You are responsible for the models, tools, provider accounts, prompts, files, and actions you choose to use with Windie.",
  },
  {
    heading: "Third-party services",
    body: "Windie can connect to model providers and optional tools. Those services have their own terms, pricing, privacy practices, and acceptable-use rules. Your use of them is governed by those terms as well as these terms.",
  },
  {
    heading: "No warranty",
    body: "Windie is provided as available. AI outputs and tool actions can be incomplete or wrong, so review important results and keep appropriate backups and safeguards. To the extent allowed by law, Windie is provided without warranties of any kind.",
  },
  {
    heading: "Changes and contact",
    body: "We may update these terms as Windie evolves. Continued use after a published update means you accept the updated terms. Questions can be sent to",
  },
];

function LegalPage({ title, description, sections }) {
  return (
    <main className="min-h-screen bg-paper text-ink">
      <Nav />
      <article className="mx-auto max-w-3xl px-6 pb-24 pt-32 md:px-10 md:pt-40">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink-50">
          Windie / Legal
        </p>
        <h1 className="mt-6 font-serif text-6xl leading-[0.92] tracking-tight md:text-8xl">
          {title}
        </h1>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-ink-70 md:text-lg">
          {description}
        </p>
        <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.16em] text-ink-30">
          Last updated August 20, 2026
        </p>

        <div className="mt-16 border-t border-ink-10">
          {sections.map((section, index) => (
            <section key={section.heading} className="border-b border-ink-10 py-10 md:py-12">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-30">
                {String(index + 1).padStart(2, "0")}
              </p>
              <h2 className="mt-3 font-serif text-3xl tracking-tight md:text-4xl">
                {section.heading}
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-ink-70 md:text-base">
                {section.body}{" "}
                {section.heading.endsWith("contact") ? (
                  <a className="text-ink underline decoration-ink-30 underline-offset-4 hover:decoration-ink" href={`mailto:${CONTACT_EMAIL}`}>
                    {CONTACT_EMAIL}
                  </a>
                ) : null}
              </p>
            </section>
          ))}
        </div>

        <p className="mt-10 text-sm leading-relaxed text-ink-50">
          <Link className="text-ink underline decoration-ink-30 underline-offset-4 hover:decoration-ink" to="/">
            Return to Windie
          </Link>
        </p>
      </article>
      <LegalFooter />
    </main>
  );
}

export function Privacy() {
  return (
    <LegalPage
      title="Privacy"
      description="This policy explains how Windie handles information when you use windieos.com and the hosted Windie Inspector."
      sections={PRIVACY_SECTIONS}
    />
  );
}

export function Terms() {
  return (
    <LegalPage
      title="Terms"
      description="These terms set the basic rules for using Windie and its hosted services."
      sections={TERMS_SECTIONS}
    />
  );
}
